import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input } from 'antd';
import React from 'react';
import AxiosServices from 'src/Services/axiosServices';

const Login: React.FC = () => {

    const [ username, setUsername ] = React.useState('');
    const [ password, setPassword ] = React.useState('');

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const onFinish = (values: any) => {
        AxiosServices.AccountLogin(values)
            .then((response) => {
                const data = response.data;
                const token = data.token;
                if (!token) {
                    alert('Unable to login. Please try after some time.');
                    return;
                }
            })
            .catch((err) => {
                // alert('Unable to login. Please try after some time.');
                alert(`${err.response.data.message}`);
            });
    }

    return (
        <Card title={"Login"}>
            <Form onFinish={onFinish}>
                <Form.Item name={"username"}
                           rules={[ {required: true, message: "Please input your username!"} ]}>
                    <Input placeholder="Username"/>
                </Form.Item>
                <Form.Item name={"password"}
                           rules={[ {required: true, message: "Please input your password!"} ]}
                >
                    <Input.Password prefix={<LockOutlined/>} placeholder="Password"/>
                </Form.Item>
                <div>
                    <a href={"/forgot"}>Mot de passe oublié ?</a>
                </div>
                <div className={"centered"}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Card>
    );

}
export default Login;
